// extracted by mini-css-extract-plugin
export default {"container":"breadCrumbsStyle_container__g4ku6","bold":"breadCrumbsStyle_bold__Kt62A","url":"breadCrumbsStyle_url__246o+","normal":"breadCrumbsStyle_normal__rwEZa"};